// re.rejouis.fr : rachat en euros (virement), au choix du client à la place du bon d'achat.
//
// Activé au lab (onglet Catalogue) sur une sélection de modèles : clé
// rachat_euros:{ pct, depuis } du metafield custom.reprise_prio (cf. prio.js).
// Montant = pct % du crédit de reprise (boost Prio compris), arrondi à l'euro.
// Plafond mensuel et champs Airtable contrôlés par le lab (rachat-euros-plafond,
// create-demande). Même contrôle d'IBAN qu'au lab (_rachatEuros.js).
//
// Module pur et partagé : panier (affichage) et demande.js (recalcul serveur).

import { lirePrio } from './prio.js';

// Taux du rachat en euros (décision Benoni 2026-10-27), = RACHAT_PCT du lab (_rachatEuros.js).
export const PCT_VIREMENT = 70;

/** % du crédit versé par virement si le modèle est activé, sinon 0. */
export function pctVirement(produit) {
  const pct = Number(lirePrio(produit?.prio)?.rachat_euros?.pct);
  return Number.isFinite(pct) && pct > 0 && pct <= 100 ? pct : 0;
}

/** Montant du virement pour un crédit donné (0 si le modèle n'est pas activé). */
export function montantVirement(credit, pct) {
  return pct > 0 && credit > 0 ? Math.round((credit * pct) / 100) : 0;
}

export const normaliseIban = (s) => String(s || '').replace(/\s+/g, '').toUpperCase();

/** IBAN au bon format et clé de contrôle juste (ISO 13616, modulo 97). */
export function ibanValide(s) {
  const iban = normaliseIban(s);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/.test(iban)) return false;
  const chiffres = (iban.slice(4) + iban.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  let reste = 0;
  for (const c of chiffres) reste = (reste * 10 + Number(c)) % 97;
  return reste === 1;
}

/** IBAN lisible par groupes de 4 (saisie et récapitulatif). */
export const formateIban = (s) => normaliseIban(s).replace(/(.{4})/g, '$1 ').trim();

/**
 * Partage du panier selon le choix fait jouet par jouet à l'écran État
 * (ligne { paiement:'virement', montantVirement }). Le reste est en bon d'achat.
 * @returns {{ virement:number, bon:number, nbVirement:number }}
 */
export function repartition(panier) {
  let virement = 0, bon = 0, nbVirement = 0;
  for (const l of panier) {
    if (l.paiement === 'virement' && l.montantVirement > 0) { virement += l.montantVirement; nbVirement += 1; }
    else bon += l.credit || 0;
  }
  return { virement, bon, nbVirement };
}

/** « 12 € + 15 € par virement » / « 15 € par virement » / « 12 € » (fmt = fmtEuro). */
export function libelleTotaux(rep, fmt) {
  if (!rep.virement) return fmt(rep.bon);
  return rep.bon > 0 ? `${fmt(rep.bon)} + ${fmt(rep.virement)} par virement` : `${fmt(rep.virement)} par virement`;
}

// Coordonnées bancaires saisies à l'étape Vérifications, gardées le temps de l'onglet jusqu'à la soumission :
// la connexion Shopify fait quitter la page. sessionStorage plutôt que localStorage
// pour ne pas laisser un IBAN traîner sur l'appareil.
const CLE = 'rj_virement';
export function enregistrerVirement(v) {
  try { if (v) sessionStorage.setItem(CLE, JSON.stringify(v)); else sessionStorage.removeItem(CLE); } catch { /* stockage indisponible */ }
}
export function lireVirement() {
  try { return JSON.parse(sessionStorage.getItem(CLE)) || null; } catch { return null; }
}
